import React, { memo } from 'react';

import { Link } from '@ergeon/core-components';

import { ROUTES } from '../../routes';
import { formatPhoneNumber } from '../Customers/utils/formatUtils';

import { CustomerInfoProps } from './types';

const CustomerInfo: React.FC<CustomerInfoProps> = memo(({ customer, phoneNumber }) => {
  return (
    <div className="flex flex-col max-w-32">
      {customer && customer.id && (
        <Link
          className="block max-w-min text-gray-900 dark:text-white hover:underline truncate paragraph-2"
          href={ROUTES.customer.$buildPath({ params: { customerId: customer.id } })}
          unstyled>
          {customer.full_name}
        </Link>
      )}
      <p className="font-bold text-gray-900 dark:text-white truncate paragraph-2">
        {phoneNumber ? formatPhoneNumber(phoneNumber) : ''}
      </p>
    </div>
  );
});

CustomerInfo.displayName = 'CustomerInfo';

export default CustomerInfo;
